import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export class Carousel {

    constructor( target = '.js-carousel', options = {} ) {
        this.target = target;

        this.options = {
            slideClass: 'js-carousel__slide',
            wrapperClass: 'js-carousel__track',
            slideActiveClass: 'js-carousel__slide--active',
            noSwipingClass: 'js-carousel__no-swipe',
            modules: [Autoplay, Navigation, Pagination],
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector( 'body' ),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init() {
        this.sliders = [];
        this.el = Array.from( document.querySelectorAll( this.target ) );

        if( this.el.length ) {
            this.sliderObserver = new IntersectionObserver( ( entries, observer ) => {
                this.create( entries, this );
            }, this.observerOptions );

            this.el.forEach( $el => {
                this.sliderObserver.observe( $el );
            });
        }
    }

    create( entries, instance ) {
        entries.forEach( ( entry ) => {
            if( entry.isIntersecting ) {

                const $el = entry.target;
                const style = $el.dataset.style;

                let options;

                let $next = $el.querySelector('.js-carousel__next');
                let $prev = $el.querySelector('.js-carousel__prev');

                if( style == 'results' ) {
                    const $parent = $el.closest('section');
                    $next = $parent.querySelector('.js-carousel__next');
                    $prev = $parent.querySelector('.js-carousel__prev');

                    options = {
                        ...this.options,
                        slidesPerView: 1.15,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-carousel__button--disabled',
                        },
                        breakpoints: {
                            621: {
                                slidesPerView: 1.6
                            },
                            767: {
                              slidesPerView: 2.2  
                            },
                            1025: {
                                slidesPerView: 3.2
                            }
                        }
                    }
                } else if( style == 'podcasts' ) {
                    const $parent = $el.closest('section');
                    $next = $parent.querySelector('.js-carousel__next');
                    $prev = $parent.querySelector('.js-carousel__prev');

                    options = {
                        ...this.options,
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-carousel__button--disabled',
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: 1.5  
                            },
                            1025: {
                                slidesPerView: 2
                            }
                        }
                    }
                } else if( style == 'banner' ) {
                    options = {
                        ...this.options,
                        autoplay: {
                            delay: 5000,
                            pauseOnMouseEnter: true,
                        },
                        slidesPerView: 1,
                        spaceBetween: 40,
                        loop: true,
                        pagination: {
                            el: ".c-contact-banner__bullets",
                            bulletClass: "c-contact-banner__bullet",
                            bulletActiveClass: "c-contact-banner__bullet--active",
                            clickable: true
                        }
                    }
                } else {
                    const $parent = $el.closest('section');
                    $next = $parent.querySelector('.js-carousel__next');
                    $prev = $parent.querySelector('.js-carousel__prev');

                    options = {
                        ...this.options,
                        slidesPerView: 1,
                        spaceBetween: 18,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-carousel__button--disabled',
                        },
                    }
                }

                this.sliders.push( new Swiper( $el, options ) );
                this.sliderObserver.unobserve( $el );
            }
        });
    }
}
